import { FieldProps } from 'formik';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    align-self: center;
    margin: 4px;
`;

const Title = styled.small`
  align-self: left !important;
`;

const Input = styled.input`
    padding: 10px;
    width: 222px;

    :hover {
        cursor: pointer;
}`;

const MandatoryMarker = styled.small`
  color: #FF0000;
`;

interface IProps {
  label: string;
  value?: string;
  mandatory: boolean;
  field?: FieldProps['field'];
  onChange: (key: string, value: string) => void;
}

const TextInput: React.FC<IProps> = ({ label, onChange, mandatory, field }) => {
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(label, event.target.value);
  };

  return (
    <Container>
      <Title>{label}</Title>
      <MandatoryMarker>{mandatory ? '*' : ''}</MandatoryMarker>
      <br />
      <Input
        type="text"
        placeholder={label}
        autoComplete="off"
        onChange={onInputChange}
        {...field}
      />
    </Container >
  );
};

export default TextInput;
